import { render, staticRenderFns } from "./SubmissionCreateModal.vue?vue&type=template&id=5ef68e7b&scoped=true"
import script from "./SubmissionCreateModal.vue?vue&type=script&lang=js"
export * from "./SubmissionCreateModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionCreateModal.vue?vue&type=style&index=0&id=5ef68e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef68e7b",
  null
  
)

export default component.exports